import React, { useState } from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useProjectModel } from '../../../model.js';
import { generateSidebarCategory } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { useWixCliAppBi } from '../../../bi/index.js';
import { useWizardStep } from '../Wizard.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

const ChooseCategoryLabelStep: FC<{
  categoryLabel?: string;
  onSubmit: (value: string) => void;
}> = ({ onSubmit, categoryLabel }) => {
  const { t } = useTranslation();
  const bi = useWixCliAppBi();
  const extensionType = t(
    'generate_command.flow.sidebar_category'
  ).toLowerCase();
  const { isActive, goToNextStep } = useWizardStep();

  return (
    <TextInput
      isActive={isActive}
      label={t('generate_command.sidebar_category.choose_label')}
      placeholder={
        categoryLabel ??
        t('generate_command.sidebar_category.label_placeholder')
      }
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: t('generate_command.sidebar_category.choose_label'),
          questionKey: 'generate_command.sidebar_category.choose_label',
          answer: value,
          additionalInfo: { extensionType },
        });
        onSubmit(value);
        goToNextStep();
      }}
    />
  );
};

export const useGenerateSidebarCategory = () => {
  const { t } = useTranslation();
  const {
    model: { projectFolder, config },
  } = useProjectModel();
  const extensionType = t(
    'generate_command.flow.sidebar_category'
  ).toLowerCase();

  const [categoryLabel, setCategoryLabel] = useState<string>();

  const generationTask = useGenerationTask(async () => {
    if (categoryLabel) {
      return generateSidebarCategory(projectFolder, config, categoryLabel);
    }
  }, [categoryLabel]);

  return [
    <ChooseCategoryLabelStep
      onSubmit={setCategoryLabel}
      categoryLabel={categoryLabel}
    />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={extensionType}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/supported-extensions/dashboard-extensions/dashboard-pages/dashboard-page-extension-files-and-code
        learnMoreUrl: 'https://wix.to/7W3nYUg',
      })}
    />,
  ];
};
